module.exports = __webpack_public_path__ + "img/0255daa.jpg";